document.querySelectorAll('.custCategoriesRpt').forEach((el, index) => {
    if ((index + 1) % 3 === 0) {
        el.querySelector('.custCategoriesTxt h3').style.color = "#000";
        el.querySelector('.custCategoriesTxt').style.left = "75%";
        el.style.width = "100%";
    }
});

